/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Real_Tree_TitleInputs */

const en_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant Real Trees`)
};

const ar_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زرع أشجار حقيقية`)
};

const de_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echte Bäume pflanzen`)
};

const es_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planta árboles reales`)
};

const fr_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantez de véritables arbres`)
};

const it_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta alberi veri`)
};

const ja_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本物の木を植える`)
};

const ko_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실제 나무 기부하기`)
};

const pt_br_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantio de árvores reais`)
};

const ru_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сажайте настоящие деревья`)
};

const th_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้จริง`)
};

const tr_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek Ağaçlar Dik`)
};

const zh_cn_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种植真树`)
};

const zh_tw_subscription_exclusive_feature_real_tree_title = /** @type {(inputs: Subscription_Exclusive_Feature_Real_Tree_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種植真樹`)
};

/**
* | output |
* | --- |
* | "Plant Real Trees" |
*
* @param {Subscription_Exclusive_Feature_Real_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_real_tree_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Real_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Real_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_real_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_real_tree_title(inputs)
	return zh_tw_subscription_exclusive_feature_real_tree_title(inputs)
});